export const ca = {
  nav: {
    problem: "El problema",
    daily: "Posicionament",
    method: "Visió",
    wins: "Microvictòries",
    blog: "Blog",
    langSwitch: "Canviar idioma",
  },
  hero: {
    eyebrow: "Punt de partida · Honestos · Sense diagnòstics",
    headline1: "Vols perdre pes",
    headline2: "però no saps per on començar?",
    subhead:
      "AI Metabolic t'ajuda a entendre on ets, què et bloqueja i quin podria ser el teu següent pas.",
    ctaNote: "Deixa'ns el teu correu i t'enviarem un test inicial. Sense diagnòstics, sense pressió i sense compromís.",
    promises: [
      { k: "On ets ara?", v: "Ens expliques què t'està costant abans de començar." },
      { k: "Què et bloqueja?", v: "Dolor, vergonya, fatiga, intents previs o falta de direcció." },
      { k: "I després?", v: "T'enviarem un test inicial i seguirem aprenent amb tu. Sense pressió ni compromís." },
    ],
    imageCaption: "Punt de partida · Calma · Sense judicis",
    quote: "\"Per primer cop\nalgú em pregunta on sóc\nabans de dir-me on he d'anar.\"",
    quoteAuthor: "Persona pilot · 52 anys",
  },
  problem: {
    eyebrow: "01 / El que ningú t'ha dit",
    h2a: "No és la teva voluntat.",
    h2b: "Mai t'han donat un mètode adaptat a tu.",
    cards: [
      {
        title: "Has escoltat sempre el mateix consell.",
        body:
          "Genèric. Repetit. Sense ningú que entengués el teu cos, el teu dolor, la teva vida real. I cada cop t'has sentit més sola.",
      },
      {
        title: "Els espais no estaven pensats per a tu.",
        body: "Màquines pensades per altres cossos. Programes que comencen on tu encara no pots. Mirades.",
      },
      {
        title: "Cada intent t'ha pesat més.",
        body: "Has tornat amb dolor, frustració i menys ganes. La motivació es gasta. La vergonya s'acumula.",
      },
      {
        title: "I sempre tornes al punt de partida.",
        body: "Plans genèrics. Cap acompanyament real. La sensació que res està fet per a tu — perquè, de fet, no ho estava.",
      },
    ],
  },
  insight: {
    eyebrow: "02 / Què canviem",
    line1: "No prometem pèrdua de pes.",
    line2a: "Ajudem persones que volen perdre pes a entendre el seu",
    capacity: "punt de partida",
    autonomy: "i què les pot estar bloquejant",
    confidence: "per prendre una millor decisió",
    line2b: ".",
    stats: [
      "Comencem on tu ets avui. No on hauries d'estar.",
      "AI METABOLIC acompanya la persona abans del primer gran pas.",
      "Sense judicis. Sense pressa. Sense vergonya.",
    ],
  },
  dailyAI: {
    eyebrow: "03 / Cada dia, al teu costat",
    h2a: "IA personalitzada.",
    h2b: "Acompanyament real.",
    intro:
      "AI METABOLIC és una IA entrenada per acompanyar persones que tornen a aprendre a moure's. Adapta la ruta al que pots fer avui — no al que hauries — i aprèn amb tu, dia a dia. Cap consell genèric. Cap solució de prestatgeria. Una activació que respira amb la teva situació real.",
    chip: "IA + persones · al teu ritme",
    features: [
      {
        label: "Activació adaptada al teu cos d'avui",
        body:
          "El que et proposem cada dia es calcula amb la teva talla, el teu dolor, la teva energia i el teu historial. Si avui pots poc, fem poc. Si pots més, pugem el llistó — mai abans del moment.",
      },
      {
        label: "Una IA que aprèn la teva situació",
        body:
          "No reps consells genèrics ni reptes copiats. La IA llegeix què t'ha funcionat, què has abandonat i per què, i ajusta la ruta perquè la pròxima setmana et toqui exactament el que necessites.",
      },
      {
        label: "Algú que mai et deixa sol",
        body:
          "T'escrivim breument cada dia. Et preguntem com estàs. Si no apareixes, reescrivim la ruta — no t'enviem a comprovar disciplina. La constància la sostenim nosaltres, no la teva voluntat.",
      },
    ],
  },
  building: {
    eyebrow: "04 / Visió futura",
    h2a: "La direcció que volem",
    h2b: "construir.",
    subtitle: "Ara mateix no oferim un programa tancat. Estem aprenent què bloqueja les persones abans de començar.",
    intro:
      "Amb aquest aprenentatge, volem construir rutes segures al costat de professionals: recuperar confiança, moure's sense por, guanyar força, millorar funcionalitat i arribar millor preparat al següent pas.",
    phases: [
      { label: "Reconnexió" },
      { label: "Força" },
      { label: "Funcionalitat" },
      { label: "Capacitat cardiorespiratòria" },
      { label: "Autonomia" },
    ],
    footnote: "Aquesta és la direcció que volem construir més endavant, amb professionals i a partir de l'aprenentatge real de les persones que s'apuntin.",
  },
  wins: {
    eyebrow: "05 / Microvictòries reals",
    h2a: "No quilos.",
    h2b: "Capacitat recuperada.",
    intro:
      "No et prometem perdre 20 kg en 3 mesos. Et prometem el contrari del que has viscut: notar — de veritat — que el teu cos torna a respondre. Petites victòries que sí canvien la teva vida.",
    list: [
      { title: "Aixecar-te d'una cadira amb menys esforç.", when: "primeres setmanes" },
      { title: "Caminar 5 minuts més sense ofegar-te.", when: "primeres setmanes" },
      { title: "Pujar un tram d'escales amb menys fatiga.", when: "següents setmanes" },
      { title: "Notar menys dolor articular al dia a dia.", when: "següents setmanes" },
      { title: "Dormir més profundament i despertar-te amb més energia.", when: "primer mes" },
      { title: "Tornar a confiar en el teu cos. I en el procés.", when: "el camí" },
    ],
    quote: "\"Sortir una mica millor del que has entrat.\"",
    quoteFooter: "Aquest és l'únic objectiu de cada sessió. La resta arriba sola.",
  },
  finalCta: {
    eyebrow: "05 / Rebre el test inicial",
    title: "Vols entendre millor",
    titleEmph: "el teu punt de partida?",
    subtitle: "Deixa'ns el teu correu i t'enviarem un test inicial per entendre millor què et pot estar bloquejant abans de començar.",
    smallnote: "No és un diagnòstic mèdic ni una recomanació clínica. Estem construint aquesta eina amb criteri i prudència.",
    button: "Rebre el test inicial",
    microcopy: "T'enviarem el test per correu. Sense spam, sense pressió i sense compromís.",
    disclaimer: "AI Metabolic no substitueix una valoració mèdica ni ofereix diagnòstic. Ara mateix estem en fase de validació i aprenentatge per construir una eina d'orientació més útil i segura.",
  },
  form: {
    success: {
      // Variant-aware messages live in ctaVariants; this is fallback
      whatsappBtn: "Continuar per WhatsApp",
    },
    hero: {
      emailPlaceholder: "el-teu@correu.cat",
    },
    full: {
      emailLabel: "Correu electrònic",
      emailRequired: "*",
      emailPlaceholder: "el-teu@correu.cat",
      whatsappLabel: "WhatsApp",
      whatsappOptional: "(opcional · més personalitzat)",
      whatsappPlaceholder: "+34 600 000 000",
      pharmacyLabel: "Codi de farmàcia",
      pharmacyOptional: "(opcional)",
      pharmacyPlaceholder: "ex. BCN-042",
      referrerLabel: "Com ens has conegut?",
      referrerSelect: "Selecciona…",
      referrerOptions: {
        farmacia: "A la farmàcia",
        xarxes: "Xarxes socials",
        amic: "Algú m'ho ha recomanat",
        cerca: "Google / cerca",
        altre: "Altre",
      },
      formNote: "Zero spam. Zero pressió. Et contactem només amb informació útil.",
      submitFallback: "Enviant…",
      almostThere: "Gairebé hi som",
      finalHeading1: "Deixa'ns el correu i et preparem",
      finalHeading2: "un primer pas adaptat a tu.",
    },
    screening: {
      stepLabel: "Pas",
      stepOf: "de",
      back: "Tornar",
      walking: {
        eyebrow: "Per entendre el teu punt de partida",
        question: "Et costa caminar 10 minuts seguits?",
        subtitle: "No hi ha resposta correcta. Només ens ajuda a saber on ets avui.",
      },
      chair: {
        eyebrow: "Una més",
        question: "Et costa aixecar-te d'una cadira sense recolzar-te?",
        subtitle: "Aquesta és la millor pista de la teva força funcional.",
      },
      difficulty: {
        eyebrow: "Última pregunta",
        question: "Quina és la teva principal dificultat avui?",
        subtitle: "Tria la que sentis més propera. Sempre podràs canviar-ho parlant amb nosaltres.",
      },
      screeningOptions: {
        yes: "Sí, em costa",
        sometimes: "A vegades",
        no: "No, ho faig sense problema",
      },
      difficultyOptions: {
        dolor: "El dolor / la fatiga",
        vergonya: "La vergonya / les mirades",
        no_se_per_on: "No saber per on començar",
        constancia: "Mantenir la constància",
        altres: "Una altra cosa",
      },
    },
    errors: {
      invalidEmail: "Introdueix un correu electrònic vàlid",
      generic: "No s'ha pogut completar. Torna-ho a provar.",
      success: "Rebut. Et contactem aviat.",
      consentRequired: "Has d'acceptar la política de privacitat per continuar.",
    },
    consent: {
      preLink: "He llegit i accepto la",
      link: "política de privacitat",
      postLink: ".",
      detail: "Tractarem les teves dades per contactar-te i preparar el teu acompanyament. Pots retirar el consentiment quan vulguis.",
    },
  },
  footer: {
    description:
      "Un sistema d'acompanyament per a persones amb obesitat. T'ajudem a recuperar capacitat, autonomia i confiança en el teu cos — pas a pas, sense judicis.",
    projectTitle: "Projecte",
    contactTitle: "Contacte",
    contactCity: "Barcelona · CAT",
    copyright: "Tots els drets reservats.",
    medical: "No substitueix l'atenció mèdica professional.",
    disclaimer: "AI METABOLIC no substitueix una valoració mèdica ni ofereix diagnòstic. Ara mateix estem en fase de validació i aprenentatge per construir una eina d'orientació més segura i útil.",
    legalTitle: "Legal",
    legalNotice: "Avís legal",
    privacyPolicy: "Política de privacitat",
    cookiePolicy: "Política de cookies",
  },
  cookieBanner: {
    ariaLabel: "Avís de cookies",
    body: "Utilitzem cookies tècniques per recordar el teu idioma i les teves preferències. No fem servir cookies de seguiment ni publicitàries.",
    policyLink: "Llegir la política de cookies",
    acceptBtn: "Acceptar",
    essentialBtn: "Només essencials",
  },
  legal: {
    backHome: "Tornar a l'inici",
    lastUpdated: "Última actualització · juny 2026",
    notice: {
      title: "Avís legal",
      s1: {
        title: "1. Identificació",
        body: "Aquest lloc web (ai-metabolic.com) està gestionat per una persona física en fase de validació del projecte. La informació de contacte del responsable es troba a la Política de Privacitat.",
      },
      s2: {
        title: "2. Dades de contacte",
        responsible: "Responsable: persona física en fase de validació",
        location: "Ubicació: Barcelona, Espanya",
        contact: "Contacte: aimetabolichealth@gmail.com",
        note: "Les dades identificatives completes del responsable es faciliten a sol·licitud directa per correu electrònic, en compliment del RGPD.",
      },
      s3: {
        title: "3. Objecte del lloc web",
        body: "AI METABOLIC és un projecte de validació centrat en oferir acompanyament personalitzat a persones amb obesitat i condicions metabòliques. Actualment recopilem expressions d'interès (waitlist) per dissenyar el servei. No oferim atenció mèdica, no substituïm cap professional sanitari i no comercialitzem cap producte des d'aquest lloc.",
      },
      s4: {
        title: "4. Condicions d'ús",
        body: "L'usuari es compromet a fer un ús correcte del lloc web, de conformitat amb la llei i amb aquest avís legal. Queda prohibit qualsevol ús que pugui danyar el funcionament del lloc o els drets de tercers.",
      },
      s5: {
        title: "5. Propietat intel·lectual",
        body: "Tots els continguts del lloc (textos, imatges, gràfics, codi) són propietat del responsable del projecte o de tercers que han autoritzat el seu ús. Queda prohibida la seva reproducció total o parcial sense autorització.",
      },
      s6: {
        title: "6. Llei aplicable",
        body: "Aquestes condicions es regeixen per la legislació espanyola. Per a qualsevol controvèrsia, les parts se sotmeten als jutjats i tribunals del domicili del responsable, excepte que la llei imposi un altre fur.",
      },
    },
    privacy: {
      title: "Política de privacitat",
      s1: {
        title: "1. Introducció",
        body: "A AI METABOLIC ens prenem molt seriosament la teva privacitat. Aquesta política explica quines dades recollim, per què, com les protegim i quins drets tens, d'acord amb el Reglament General de Protecció de Dades (RGPD - UE 2016/679) i la LOPDGDD (3/2018).",
      },
      s2: {
        title: "2. Responsable del tractament",
        responsible: "Responsable: Josep Mora Barberà",
        location: "Ubicació: Barcelona (Espanya)",
        contact: "Contacte per a temes de privacitat: aimetabolichealth@gmail.com",
      },
      s3: {
        title: "3. Quines dades recollim",
        intro: "Quan t'apuntes a la nostra llista d'espera, recollim:",
        item1: "Dades de contacte: correu electrònic (obligatori) i número de WhatsApp (opcional).",
        item2: "Dades del formulari de screening: respostes a tres preguntes sobre la teva capacitat funcional (caminar, aixecar-se) i sobre la teva dificultat principal.",
        item3: "Dades tècniques i de procedència: codi de farmàcia (opcional), com ens has conegut, paràmetres UTM (font de la campanya), variant del CTA.",
        item4: "Marca temporal del consentiment i del registre.",
        healthNote: "ATENCIÓ: Algunes respostes del screening poden constituir dades de salut (categoria especial segons l'art. 9 RGPD). Tractarem aquestes dades únicament amb el teu consentiment explícit i amb mesures de seguretat reforçades. Pots optar per no respondre el screening i deixar només el correu.",
      },
      s4: {
        title: "4. Finalitat del tractament",
        purpose1: "Contactar-te per oferir-te informació sobre l'acompanyament que estem dissenyant.",
        purpose2: "Personalitzar l'acompanyament en funció de les teves respostes (només si has acceptat compartir-les).",
        purpose3: "Mesurar l'efectivitat de les nostres campanyes de difusió (de forma agregada i anònima).",
      },
      s5: {
        title: "5. Base legal",
        body: "El tractament es basa en el teu consentiment explícit (art. 6.1.a i, per a dades de salut, art. 9.2.a RGPD). Pots retirar el consentiment en qualsevol moment escrivint a aimetabolichealth@gmail.com sense que això afecti la licitud del tractament previ.",
      },
      s6: {
        title: "6. Proveïdors i transferències",
        body: "Per oferir-te aquest servei, comptem amb proveïdors externs que actuen com a encarregats del tractament:",
        provider1: "MongoDB Atlas (allotjament de la base de dades) — servidors a la UE.",
        provider2: "Resend (servei d'enviament de correus electrònics) — servidors als EUA amb clàusules contractuals tipus (SCC) de la UE.",
        provider3: "Emergent (plataforma d'allotjament del lloc web) — infraestructura conforme amb el RGPD.",
        note: "Totes les transferències internacionals es realitzen amb les garanties que estableix el RGPD (clàusules contractuals tipus o decisions d'adequació).",
      },
      s7: {
        title: "7. Termini de conservació",
        body: "Conservarem les teves dades mentre mantinguis interès en el servei o fins que ens sol·licitis la seva supressió. En qualsevol cas, com a màxim 24 mesos des de l'últim contacte, transcorreguts els quals procedirem a la seva eliminació, llevat d'obligacions legals que imposin la seva conservació.",
      },
      s8: {
        title: "8. Els teus drets",
        intro: "Pots exercir els següents drets en qualsevol moment:",
        right1: "Accés: saber quines dades teves tenim.",
        right2: "Rectificació: corregir dades inexactes.",
        right3: "Supressió (dret a l'oblit): que esborrem les teves dades.",
        right4: "Limitació: restringir el tractament en certs supòsits.",
        right5: "Portabilitat: rebre les teves dades en un format estàndard.",
        right6: "Oposició: oposar-te al tractament per motius personals.",
        howTo: "Per exercir qualsevol d'aquests drets, escriu-nos a aimetabolichealth@gmail.com indicant el dret que vols exercir i adjuntant una còpia del teu DNI o document equivalent. Respondrem en el termini màxim d'un mes.",
        complaint: "Si consideres que el tractament no s'ajusta a la normativa, tens dret a presentar una reclamació davant l'Agència Espanyola de Protecció de Dades (www.aepd.es).",
      },
      s9: {
        title: "9. Seguretat",
        body: "Apliquem mesures tècniques i organitzatives adequades per protegir les teves dades contra l'accés no autoritzat, la pèrdua o l'alteració: xifratge en trànsit (HTTPS), control d'accés a la base de dades, còpies de seguretat i revisions periòdiques.",
      },
      s10: {
        title: "10. Canvis en aquesta política",
        body: "Podem actualitzar aquesta política per adaptar-la a canvis legals o operatius. La data de l'última actualització es mostra a la part superior. Et recomanem revisar-la periòdicament.",
      },
    },
    cookies: {
      title: "Política de cookies",
      s1: {
        title: "1. Què són les cookies",
        body: "Les cookies són petits fitxers de text que s'emmagatzemen al teu navegador quan visites un lloc web. Permeten que el lloc recordi les teves preferències i et reconegui entre visites.",
      },
      s2: {
        title: "2. Quin tipus de cookies fem servir",
        body: "AI METABOLIC només utilitza cookies tècniques estrictament necessàries per al funcionament del lloc. NO utilitzem cookies de tercers, de seguiment publicitari, ni d'anàlisi (com Google Analytics o Meta Pixel).",
        note: "Si en el futur incorporem cookies analítiques o de tercers, et demanarem el teu consentiment explícit abans d'activar-les.",
      },
      s3: {
        title: "3. Cookies utilitzades",
        col1: "Nom",
        col2: "Finalitat",
        col3: "Durada",
        row1Desc: "Recorda l'idioma seleccionat (català/castellà) entre visites.",
        row2Desc: "Recorda la teva decisió sobre aquest avís de cookies.",
        persistent: "Persistent (fins esborrar)",
        note: "Tècnicament, fem servir localStorage, no cookies HTTP convencionals. La normativa europea aplica les mateixes obligacions a ambdós sistemes.",
      },
      s4: {
        title: "4. Com gestionar-les",
        body: "Pots esborrar les dades emmagatzemades del lloc en qualsevol moment des de la configuració del teu navegador (apartat 'Privacitat' o 'Dades del lloc'). En esborrar-les, perdràs la preferència d'idioma i tornarem a mostrar-te el banner de cookies.",
      },
      s5: {
        title: "5. Més informació",
        body: "Per a més detalls sobre com tractem les teves dades, consulta la nostra Política de Privacitat.",
      },
    },
  },
  ctaVariants: {
    info: {
      eyebrowFinal: "Entendre el meu punt de partida",
      heroButton: "Vull entendre el meu punt de partida",
      navButton: "Entendre el punt de partida",
      finalButton: "Respondre les preguntes",
      finalH2Pre: "Respon unes preguntes breus.",
      finalH2Mid: "No és un diagnòstic mèdic ni una recomanació clínica.",
      finalH2Post: "Ens ajuda a entendre què et pot estar bloquejant i a construir una orientació més útil i segura.",
      finalDescription:
        "Estem en fase de validació i aprenentatge. Volem entendre què bloqueja persones com tu abans de proposar res. Et contactarem amb el que vagim aprenent i, si vols, podrem parlar per entendre millor el teu cas.",
      successTitle: "T'hem rebut",
      successBody:
        "Gràcies. Aviat et farem arribar un test inicial per ajudar-te a entendre millor el teu punt de partida. Sense pressa, sense compromisos i sense judicis.",
    },
    plan: {
      eyebrowFinal: "El meu primer pas",
      heroButton: "Vull el meu primer pas",
      navButton: "El meu primer pas",
      finalButton: "Crear el meu primer pas",
      finalH2Pre: "Comencem pel teu",
      finalH2Mid: "primer pas —",
      finalH2Post: "el que el teu cos pot avui.",
      finalDescription:
        "Deixa'ns el correu i, en menys de 24h, t'expliquem com seria el teu primer pas adaptat a tu. Sense canviar tota la teva vida d'un dia per l'altre.",
      successTitle: "Tenim les teves dades",
      successBody:
        "En menys de 24h rebràs al correu el teu primer pas, pensat per a tu. T'escriurem per WhatsApp per acabar d'ajustar-lo amb tu — sense pressió.",
    },
    reserva: {
      eyebrowFinal: "Reserva el teu lloc",
      heroButton: "Reservar el meu lloc",
      navButton: "Reserva el lloc",
      finalButton: "Reservar el meu lloc",
      finalH2Pre: "Reserva el teu lloc",
      finalH2Mid: "a la primera cohort.",
      finalH2Post: "Acompanyament limitat.",
      finalDescription:
        "La primera cohort és petita perquè volem acompanyar bé cada persona. Deixa'ns el correu i et guardem el lloc mentre el revisem amb tu — sense compromís de pagament.",
      successTitle: "Lloc reservat",
      successBody:
        "Tens el lloc reservat provisionalment. T'escriurem en menys de 24h per confirmar-lo i explicar-te els següents passos — per correu i, si vols, per WhatsApp.",
    },
    whatsapp: {
      eyebrowFinal: "Parlem un moment",
      heroButton: "Parlem un moment",
      navButton: "Parlem",
      finalButton: "Començar la conversa",
      finalH2Pre: "Parlem un moment.",
      finalH2Mid: "Sense formularis llargs.",
      finalH2Post: "Una persona real, no un bot.",
      finalDescription:
        "Deixa'ns el correu i el WhatsApp. Una persona del nostre equip t'escriurà en menys de 24h per entendre la teva situació — al teu ritme, sense pressió.",
      successTitle: "T'escrivim aviat",
      successBody:
        "Una persona del nostre equip t'escriurà en menys de 24h. Si vols accelerar la conversa, pots començar tu mateix al WhatsApp clicant el botó de sota.",
    },
  },
};
